// Открытие ЧУЖОГО разбора по диплинку (#/s/<payload>): парсим payload → лоадер →
// грузим именно эту партию → кладём в state и открываем обычный #/game/:id со всеми
// возможностями. Пометка state.sharedId включает в разборе латунную «Разобрать свои
// партии» и увод BackButton на экран ника. Ошибка/битый параметр → человеческое
// состояние с кнопкой на #/.
import { t } from '../i18n';
import { state, setGames } from '../state';
import { parseDeeplinkPayload } from '../core/deeplink';
import { fetchGameByRef } from '../services/game-fetch';
import { showBackButton, hideMainButton } from '../tg';

function shell(inner: string): string {
  return `
    <header class="topbar">
      <span class="back" data-home>${t('top.back')}</span>
      <span class="top-title"><span class="top-logo" aria-hidden="true"></span>${t('game.title')}</span>
      <span class="top-action"></span>
    </header>
    ${inner}`;
}

function loading(): string {
  return `<section class="card state-card"><span class="skel-pill"></span>
    <p class="muted">${t('shared.loading')}</p></section>`;
}

function errorState(root: HTMLElement): void {
  root.innerHTML = shell(`
    <section class="card state-card"><span class="icon">\u{1f61f}</span>
      <p class="muted">${t('shared.error')}</p>
      <button type="button" class="inline-cta" data-own>${t('game.analyze_own')}</button></section>`);
  root.querySelector<HTMLElement>('[data-own]')?.addEventListener('click', goHome);
  root.querySelector<HTMLElement>('[data-home]')?.addEventListener('click', goHome);
}

function goHome(): void {
  state.sharedId = null;
  location.hash = '#/';
}

// Дедуп: на старте установка hash + явный render() могут дёрнуть экран дважды —
// не грузим одну и ту же партию повторно, пока идёт запрос.
let loadingPayload: string | null = null;

export function renderShared(root: HTMLElement, payload: string): void {
  const ref = parseDeeplinkPayload(payload);
  root.className = 'app v2';
  hideMainButton();
  showBackButton(goHome);
  if (!ref) {
    errorState(root);
    return;
  }
  if (loadingPayload === payload) return; // уже грузим этот payload
  loadingPayload = payload;
  root.innerHTML = shell(loading());
  root.querySelector<HTMLElement>('[data-home]')?.addEventListener('click', goHome);

  fetchGameByRef(ref)
    .then((game) => {
      if (!location.hash.startsWith('#/s/')) return; // ушли, пока грузили
      state.source = ref.site === 'lichess' ? 'lichess' : 'chesscom';
      state.nick = ref.nick;
      setGames([game]);
      state.selectedId = game.id;
      state.sharedId = game.id;
      location.hash = `#/game/${encodeURIComponent(game.id)}`;
    })
    .catch(() => {
      if (location.hash.startsWith('#/s/')) errorState(root);
    })
    .finally(() => {
      loadingPayload = null;
    });
}
